import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

export default function RewardConfigPanel() {
  const [configs, setConfigs] = useState([]);
  const [edits, setEdits] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get('/admin/reward-config').then(data => {
      setConfigs(data);
      const initial = {};
      data.forEach(c => { initial[c.config_key] = c.config_value; });
      setEdits(initial);
    }).catch(() => {});
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      const items = Object.entries(edits).map(([config_key, config_value]) => ({ config_key, config_value }));
      await api.put('/admin/reward-config', { configs: items });
      setMsg({ type: 'success', text: 'Saved — config refreshed' });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setSaving(false);
    }
  };

  // Group by prefix
  const pointsEntries = Object.entries(edits).filter(([k]) => k.startsWith('points_')).sort((a, b) => parseFloat(a[0].split('_')[1]) - parseFloat(b[0].split('_')[1]));
  const spinsEntries = Object.entries(edits).filter(([k]) => k.startsWith('spins_')).sort((a, b) => parseFloat(a[0].split('_')[1]) - parseFloat(b[0].split('_')[1]));

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Reward Config</h3>

      {msg && (
        <div style={{ padding: '8px 12px', borderRadius: 'var(--radius-sm)', marginBottom: 12, fontSize: 13,
          background: msg.type === 'success' ? 'rgba(72,187,120,0.1)' : 'rgba(252,129,129,0.1)',
          color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
          border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
        }}>
          {msg.text}
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        <h4 style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>Points Per Weight</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: 8 }}>
          {pointsEntries.map(([key, val]) => {
            const grams = key.replace('points_', '');
            return (
              <div key={key} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>{grams}g</div>
                <input
                  type="number"
                  value={val}
                  onChange={e => setEdits(prev => ({ ...prev, [key]: e.target.value }))}
                  style={{ textAlign: 'center', padding: '6px' }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <h4 style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>Spins Per Weight</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: 8 }}>
          {spinsEntries.map(([key, val]) => {
            const grams = key.replace('spins_', '');
            return (
              <div key={key} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>{grams}g</div>
                <input
                  type="number"
                  value={val}
                  onChange={e => setEdits(prev => ({ ...prev, [key]: e.target.value }))}
                  style={{ textAlign: 'center', padding: '6px' }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <button className="btn-primary btn-small" onClick={handleSave} disabled={saving}>
        {saving ? 'Saving...' : 'Save Config'}
      </button>
    </div>
  );
}
